import { render, staticRenderFns } from "./SectionShow.vue?vue&type=template&id=4af3445e&"
import script from "./SectionShow.vue?vue&type=script&lang=js&"
export * from "./SectionShow.vue?vue&type=script&lang=js&"
import style0 from "./SectionShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports